// import React, { useEffect, useState } from "react";
// import { MdOutlineArrowBackIos } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUsers } from "../../redux/slices/userSlice";
// import TableComponent from "../../components/common/TableComponent";
// import { FiDownload } from "react-icons/fi";

//   const statusClasses = {
//     Active: "bg-green-100 text-green-800",
//     Inactive: "bg-red-100 text-red-800",
//     Approved: "bg-green-100 text-green-800",
//     Pending: "bg-yellow-100 text-yellow-600",
//     Rejected: "bg-red-100 text-red-600",
//     Default: "bg-gray-100 text-gray-600",
//   };

// export default function UserManagement() {
//   const [activeTab, setActiveTab] = useState("Pet Parents");
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const petParents = useSelector((state) => state.users.petParents);
//   const veterinarians = useSelector((state) => state.users.veterinarians);
//   const status = useSelector((state) => state.users.listStatus);

//   useEffect(() => {
//     const type = activeTab === "Pet Parents" ? "pet-parents" : "veterinarians";
//     dispatch(fetchUsers(type));
//   }, [dispatch, activeTab]);

//   const users = activeTab === "Pet Parents" ? petParents : veterinarians;

//   const handleRowClick = (user) => {
//     navigate(
//       `/swift-app/admin/profile/${activeTab.toLowerCase().replace(" ", "-")}/${user.uuid}`
//     );
//   };

//   // Define columns based on active tab
//   const columns =
//     activeTab === "Pet Parents"
//       ? [
//           { key: "user_code", label: "User Code" },
//           { key: "name", label: "Name" },
//           { key: "pet_count", label: "Pets" },
//           { key: "city_name", label: "City" },
//           {
//             key: "active",
//             label: "Status",
//             render: (val) => (
//               <span
//                 className={`px-3 py-[2px] rounded-[5px] text-sm ${
//                   statusClasses[val ? "Active" : "Rejected"]
//                 }`}
//               >
//                 {val ? "Active" : "In Active"}
//               </span>
//             ),
//           },
//           { key: "appointments_counts", label: "Appointments" },
//         ]
//       : [
//           { key: "user_code", label: "User Code" },
//           { key: "name", label: "Name" },
//           { key: "specialty", label: "Specialty" },
//           { key: "city_name", label: "City" },
//           // { key: "rating", label: "Rating" }, // Commented out for future
//           {
//             key: "kycStatus",
//             label: "KYC Status",
//             render: (val) => {
//               const statusMap = {
//                 approved: "Approved",
//                 pending: "Pending",
//                 rejected: "Rejected",
//               };
//               return (
//                 <span
//                   className={`px-3 py-[2px] rounded-[5px] text-sm ${
//                     statusClasses[statusMap[val] || "Default"]
//                   }`}
//                 >
//                   {statusMap[val] || "N/A"}
//                 </span>
//               );
//             },
//           },
//           { key: "consultation_count", label: "Consultations" },
//         ];

//   // Custom cell renderer for badges
//   const renderCell = (key, value) => {
//     if (key === "status" || key === "kycStatus") {
//       return (
//         <span
//           className={`px-3 py-[2px] rounded-[5px] text-sm ${
//             statusClasses[value] || ""
//           }`}
//         >
//           {value}
//         </span>
//       );
//     }
//     return value;
//   };

//   // Navigate to ExportPage
//   const handleExportClick = () => {
//     navigate(`/swift-app/admin/export?tab=${activeTab.replace(" ", "")}`);
//   };

//   return (
//     <div className="px-2 pt-8 font-inter min-h-screen bg-white">
//       {/* Header */}
//       <div className="flex justify-between items-center">
//         <div>
//           <div className="flex items-center gap-1 text-black font-semibold text-2xl mb-1">
//             <button
//               onClick={() => navigate(-1)}
//               aria-label="Go Back"
//               className="mt-1 p-4 text-2xl text-gray-800 hover:text-blue-600"
//             >
//               <MdOutlineArrowBackIos />
//             </button>
//             User Management
//           </div>
//           <div className="text-gray-700 ml-15">
//             Manage Pet Parents and Veterinarians
//           </div>
//         </div>

//         {/* ✅ Export button navigates to ExportPage */}
//         <button
//           onClick={handleExportClick}
//           className="flex items-center gap-2 bg-blue-500 text-white text-lg font-medium px-8 py-2.5 rounded-lg shadow hover:bg-blue-600 transition"
//         >
//           Export <FiDownload className="w-5 h-5" />
//         </button>
//       </div>

//       {/* Tabs */}
//       <div className="flex mt-10 mb-4 pl-14">
//         {["Pet Parents", "Veterinarians"].map((tab) => (
//           <button
//             key={tab}
//             onClick={() => setActiveTab(tab)}
//             className={`px-9 py-3 rounded-xl text-lg font-semibold transition
//               ${
//                 activeTab === tab
//                   ? "bg-white text-gray-900 border border-gray-200 shadow-[0_3px_20px_0_rgba(30,37,42,0.07)]"
//                   : "bg-transparent text-gray-400 border-transparent"
//               }`}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="mt-12 pl-10">
//         {status === "loading" ? (
//           <div>Loading...</div>
//         ) : (
//           <TableComponent
//             columns={columns}
//             data={users}
//             renderCell={renderCell}
//             onRowClick={handleRowClick}
//           />
//         )}
//       </div>
//     </div>
//   );
// }


/**
 * User Management Page
 * - Displays pet parents and veterinarians
 * - Supports pagination and search
 * - Allows viewing user profiles
 * - Includes export functionality
 */

import React, { useEffect, useState } from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../../redux/slices/userSlice";
import TableComponent from "../../components/common/TableComponent";
import { FiDownload } from "react-icons/fi";
import { Verified } from "lucide-react";

const statusClasses = {
  Active: "bg-green-100 text-green-800",
  Inactive: "bg-red-100 text-red-800",
  Approved: "bg-green-100 text-green-800",
  Verified: "bg-green-100 text-green-800",
  Pending: "bg-yellow-100 text-yellow-600",
  Rejected: "bg-red-100 text-red-600",
  Default: "bg-gray-100 text-gray-600",
};

export default function UserManagement() {
  const [activeTab, setActiveTab] = useState("Pet Parents");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const petParents = useSelector((state) => state.users.petParents);
  const veterinarians = useSelector((state) => state.users.veterinarians);
  const status = useSelector((state) => state.users.listStatus);
  const pagination = useSelector((state) => state.users.pagination);

  useEffect(() => {
    const type = activeTab === "Pet Parents" ? "pet-parents" : "veterinarians";
    const currentPage = pagination[type]?.currentPage || 1;
    dispatch(fetchUsers({ userType: type, page: currentPage }));
  }, [dispatch, activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  const users = activeTab === "Pet Parents" ? petParents : veterinarians;
  const currentPagination = activeTab === "Pet Parents"
    ? pagination.petParents
    : pagination.veterinarians;

  const handlePageChange = (page) => {
    const type = activeTab === "Pet Parents" ? "pet-parents" : "veterinarians";
    dispatch(fetchUsers({ userType: type, page }));
  };

  const handleRowClick = (user) => {
    navigate(
      `/swift-app/admin/profile/${activeTab.toLowerCase().replace(" ", "-")}/${user.uuid}`
    );
  };

  const columns =
    activeTab === "Pet Parents"
      ? [
          {
            key: "index",
            label: "Index",
            render: (val, row, index) => {
              const currentPage = currentPagination?.currentPage || 1;
              const itemsPerPage = currentPagination?.itemsPerPage || 10;
              return (currentPage - 1) * itemsPerPage + index + 1;
            }
          },
          { key: "name", label: "Name" },
          { key: "pet_count", label: "Pets" },
          { key: "city_name", label: "City" },
          {
            key: "active",
            label: "Status",
            render: (val) => (
              <span
                className={`px-3 py-[2px] rounded-[5px] text-sm ${
                  statusClasses[val ? "Active" : "Rejected"]
                }`}
              >
                {val ? "Active" : "Inactive"}
              </span>
            ),
          },
          { key: "appointments_counts", label: "Appointments" },
        ]
      : [
          {
            key: "index",
            label: "Index",
            render: (val, row, index) => {
              const currentPage = currentPagination?.currentPage || 1;
              const itemsPerPage = currentPagination?.itemsPerPage || 10;
              return (currentPage - 1) * itemsPerPage + index + 1;
            }
          },
          { key: "name", label: "Name" },
          { key: "specialty", label: "Specialty" },
          { key: "city_name", label: "City" },
          {
            key: "kycStatus",
            label: "KYC Status",
            render: (val) => {
              const statusMap = {
                approved: "Approved",
                verified: "Verified",
                pending: "Pending",
                rejected: "Rejected",
              };
              return (
                <span
                  className={`px-3 py-[2px] rounded-[5px] text-sm ${
                    statusClasses[statusMap[val] || "Default"]
                  }`}
                >
                  {statusMap[val] || "N/A"}
                </span>
              );
            },
          },
          { key: "consultation_count", label: "Consultations" },
        ];

  // const handleExportClick = () => {
  //   navigate(`/swift-app/admin/export?tab=${activeTab.replace(" ", "")}`);
  // };

  return (
    <div className="px-3 sm:px-6 md:px-8 lg:px-12 pt-6 md:pt-8 font-inter min-h-screen bg-white">
      {/* ✅ Header */}
      <div className="flex flex-col gap-4">
        {/* Top Row — Back button + Title + Export */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              aria-label="Go Back"
              className="p-2 md:p-3 text-lg md:text-xl text-gray-800 hover:text-blue-600"
            >
              <MdOutlineArrowBackIos />
            </button>
            <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900">
              User Management
            </h1>
          </div>

         {/* ✅ Responsive Export button */}
             {/* Icon always visible */}
          {/* <button
            onClick={handleExportClick}
            className="flex items-center justify-center gap-2 bg-blue-500 text-white font-medium px-3 sm:px-4 md:px-5 py-2 rounded-lg shadow hover:bg-blue-600 transition"
          >
         
            <FiDownload className="w-5 h-5" />
            <span className="hidden lg:inline">Export</span>
          </button> */}
        </div>

        {/* Subtitle */}
        <p className = "text-gray-600 text-sm sm:text-base ml-10 md:ml-14">
          Manage Pet Parents and Veterinarians
        </p>
      </div>

      {/* ✅ Tabs */}
      <div className="flex justify-center md:justify-start flex-wrap gap-3 sm:gap-5 mt-8 mb-4">
        {["Pet Parents", "Veterinarians"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-5 sm:px-7 md:px-9 py-2.5 sm:py-3 rounded-xl text-sm sm:text-base md:text-lg font-semibold transition ${
              activeTab === tab
                ? "bg-white text-gray-900 border border-gray-200 shadow-[0_3px_20px_0_rgba(30,37,42,0.07)]"
                : "bg-transparent text-gray-400 border border-transparent"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* ✅ Table */}
      <div className="mt-8 md:mt-10 overflow-x-auto">
        {status === "loading" ? (
          <div className="text-center text-gray-500 py-10 text-sm md:text-base">
            Loading...
          </div>
        ) : (
          <TableComponent
            columns={columns}
            data={users}
            onRowClick={handleRowClick}
            currentPage={currentPagination?.currentPage || 1}
            totalPages={currentPagination?.totalPages || 1}
            totalItems={currentPagination?.totalItems || 0}
            itemsPerPage={currentPagination?.itemsPerPage || 10}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
}
